
import styles from './applicationLoader.module.scss';
import cx from 'classnames';

export function Loader({ title, className }) {
  return (
    <div className={cx(styles.loaderContainer, className)}>
      <div className={styles.loaderVideoWrapper}>
        <video className={styles.loaderMessageVideo} loop autoPlay playsInline muted>
          <source src="/images/Workspaceloader.webm" type="video/webm" />
        </video>
        <label className={styles.loaderMessage}>{title}</label>
      </div>
    </div>
  )
}

export function ShortLoader({ title, className }) {

  return (
    <div className={cx(styles.loaderContainer, className)}>
      <div className={styles.loaderVideoWrapper}>
        <video className={styles.loaderMessageVideo} loop autoPlay playsInline muted>
          <source src="/images/shortLoader.mp4" type="video/mp4" />
        </video>
        <label className={styles.loaderMessage}>{title}</label>
      </div>
    </div>
  )
}